import {logService} from 'services/log';
import {withProxy} from 'interactors/errorHandler';
import {withContract} from 'interactors/contracts';
import {createPublisher as factory} from '../Publisher';
import {MessageContract as Contract} from '../contract';
import {createReceiver} from './factory';

const contractedFactory = withContract(factory, 'notify', Contract);
const protectedFactory = withProxy({
  factory: contractedFactory,
  handler: logService.log,
  methods: ['notify'],
}) as PublisherFactory;

export const MessageReceiver = createReceiver({publisherFactory: protectedFactory});
